import React, { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { ModalContext } from '@/utils/contexts/ModalContext';

import Spinner from '@/views/components/Spinner/Spinner';

import styles from '@/views/components/Modal/ModalDelete.module.scss';

const ModalDeleteTemplate = () => {
	const { dict } = useSelector((state) => state.app);
	const [ requestIsPending, setRequestIsPending ] = useState(false);

	const { closeModal, 
		modalAdditionalInfo: { id, callbackFunction },
	} = useContext(ModalContext);

	const deleteFile = async () => {
		if (callbackFunction) {
			setRequestIsPending(true);
			await callbackFunction(id);
			setRequestIsPending(false);
			closeModal();
		}
	};

	return (
		<div className='modal__content modal__delete-file'>
			{ requestIsPending && (
				<div className='letter__edit-metadata--spinner'>
					<Spinner />
				</div>
			) }
			<div className={ styles['delete'] }>
				<h3 className={ styles['delete--title'] }>
					{dict.modals.deleteTemplate.head}
				</h3>

				<div className={ styles['delete--comment'] }>
					<p>{dict.modals.deleteTemplate.comment1}</p>
					<p>{dict.modals.deleteTemplate.comment2}</p>
				</div>

				<section className={ styles['delete--buttons'] }>
					<div
						className='button__std'
						onClick={
							closeModal
						}
					>
						{dict.cancel}
					</div>
					<div
						className='button__blue'
						onClick={ deleteFile }
					>
						{dict.modals.deleteTemplate.delete}
					</div>
				</section>
			</div>
		</div>
	);
};

export default ModalDeleteTemplate;